enum TriggerRoadSpeedSeverity {
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  HIGHER = 'HIGHER',
}

interface TriggerRoadSpeed {
  speedLimitInKmH: number;
  medianSpeedInKmH: number;
  medianBasedSeverity: TriggerRoadSpeedSeverity;
}

export { TriggerRoadSpeedSeverity };
export default TriggerRoadSpeed;
